/* Welcome pop-up behaviour. Loaded with defer from sections/welcome-popup.liquid.
   Shows once the page has loaded (+ the delay set in the theme editor), waits while Shopify's
   cookie-consent banner is on screen so the two never stack, remembers
   the dismissal in localStorage for N days, traps focus while open, returns focus on close.
   Revisions: 2026-10-01 created (Kai, PKA #12222). */
(function () {
  'use strict';

  var DAY = 86400000;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var state = { timer: null, root: null, opener: null, onKey: null };

  function store(kind) {
    try {
      var s = window[kind];
      var k = '__kf_t';
      s.setItem(k, '1');
      s.removeItem(k);
      return s;
    } catch (e) {
      return null;
    }
  }

  function wasDismissed(key, days) {
    var s = store('localStorage') || store('sessionStorage');
    if (!s) return false;
    try {
      var at = parseInt(s.getItem(key), 10);
      return !isNaN(at) && Date.now() - at < days * DAY;
    } catch (e) {
      return false;
    }
  }

  function remember(key) {
    var s = store('localStorage') || store('sessionStorage');
    if (!s) return;
    try {
      s.setItem(key, String(Date.now()));
    } catch (e) {}
  }

  function setup() {
    var root = document.querySelector('[data-welcome-popup]');
    if (!root || root === state.root) return;
    teardown();
    state.root = root;

    var design = !!(window.Shopify && window.Shopify.designMode);
    var days = parseFloat(root.getAttribute('data-days')) || 30;
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 1500;
    var key = 'kf_welcome_v' + (root.getAttribute('data-version') || '1');
    var dialog = root.querySelector('[data-welcome-dialog]');
    var backdrop = root.querySelector('[data-welcome-backdrop]');
    var wrapper = document.querySelector('.site-wrapper');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var open = false;

    if (!design && wasDismissed(key, days)) return;

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    }

    function close() {
      if (!open) return;
      open = false;
      if (!design) remember(key);
      document.removeEventListener('keydown', state.onKey, true);
      root.classList.remove('is-open');
      if (wrapper) wrapper.inert = false;

      var done = function () {
        root.hidden = true;
      };
      if (reduce) done();
      else setTimeout(done, 520);

      var back = state.opener;
      if (!back || !document.contains(back) || back === document.body) back = document.getElementById('MainContent');
      if (back && back.focus) {
        try {
          back.focus({ preventScroll: true });
        } catch (e) {
          back.focus();
        }
      }
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        e.stopPropagation();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) {
        e.preventDefault();
        return;
      }
      var first = f[0];
      var last = f[f.length - 1];
      var a = document.activeElement;
      if (!dialog.contains(a)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && (a === first || a === dialog)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && a === last) {
        e.preventDefault();
        first.focus();
      }
    }
    state.onKey = onKey;

    root.querySelectorAll('[data-welcome-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) close();
    });

    function show() {
      if (open) return;
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !design) return;
      open = true;
      state.opener = a && a !== document.body ? a : null;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      if (wrapper) wrapper.inert = true;
      document.addEventListener('keydown', onKey, true);
      try {
        dialog.focus({ preventScroll: true });
      } catch (e) {
        dialog.focus();
      }
    }

    function consentOpen() {
      var el = document.getElementById('shopify-pc__banner');
      return !!(el && el.getClientRects().length);
    }

    function attempt() {
      if (open) return;
      if (consentOpen()) {
        state.timer = setTimeout(attempt, 600);
        return;
      }
      show();
    }

    function schedule() {
      state.timer = setTimeout(attempt, delay);
    }

    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  function teardown() {
    if (state.timer) clearTimeout(state.timer);
    state.timer = null;
    if (state.onKey) document.removeEventListener('keydown', state.onKey, true);
    var wrapper = document.querySelector('.site-wrapper');
    if (wrapper) wrapper.inert = false;
    state.root = null;
  }

  setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', teardown);
})();
